import { Route, Switch, Redirect } from "react-router-dom";

import { encryptStorage } from "../../constants/EncryptStorage";
import SMSReport from "../SMSMessage/SMSReport";
import Ahbab from "../ahbab/Ahbab";
import AhbabProgressBoard from "../ahbab/AhbabProgressBoard";
import AddHabib from "../ahbab/ContactFormAhbab/AddHabib";
import AhbabFromContactForm from "../ahbab/ContactFormAhbab/AhbabFromContactForm";
import EditHabib from "../ahbab/ContactFormAhbab/EditHabib";
import AhbabFromContactFormReport from "../ahbab/ContactFormAhbab/report/AhbabFromContactFormReport";
import AhbabFromContactUsFormAnalyticsReport from "../ahbab/ContactFormAhbab/report/AhbabFromContactUsFormAnalyticsReport";
import QuickTanzeemOrgAhbabReports from "../ahbab/ContactFormAhbab/report/QuickTanzeemOrgAhbabReports";
import AhbabReport from "../ahbab/report/AhbabReport";
import Books from "../books/Books";
import Configuration from "../config/Configuration";
import Education from "../config/education/Education";
import AddCourse from "../courses/AddCourse";
import CourseParticipants from "../courses/CourseParticipants";
import Courses from "../courses/Courses";
import EditCourse from "../courses/EditCourse";
import CourseParticipantsReport from "../courses/report/CourseParticipants";
import CourseReport from "../courses/report/CourseReport";
import DashBoard from "../dashboard/Dashboard";
import EventDetail from "../dashboard/EventDetail";
// import Documents from "../documents/Documents";
import AddEvent from "../events/AddEvent";
import EditEvent from "../events/EditEvent";
import EventAttendance from "../events/EventAttendance";
import EventBarCodeAttendance from "../events/EventBarCodeAttendance";
import EventInChargeAndResponsibleParticipants from "../events/EventInChargeAndResponsibleParticipants";
import EventParticipants from "../events/EventParticipants";
import EventResponsibleParticipant from "../events/EventResponsibleParticipant";
import Events from "../events/Events";
import SelectiveEventParticipants from "../events/SelectiveEventParticipants";
import EventReport from "../events/report/EventReport";
import EventReportWithNoAttendance from "../events/report/EventReportWithNoAttendance";
import EventSummaryReport from "../events/report/EventSummaryReport/EventSummaryReport";
import EventWiseEventAttendance from "../events/report/EventWiseEventAttendance";
import QuickEventReports from "../events/report/QuickEventReports";
import RafiqWiseEventAttendance from "../events/report/RafiqWiseEventAttendance";
import UnitWiseEventAttendance from "../events/report/UnitWiseEventAttendance";
import AddBulkFund from "../funds/AddBulkFund";
import Funds from "../funds/Funds";
import LetterForCounselling from "../letterForCounselling/LetterForCounselling";
import ListToSendLFC from "../letterForCounselling/reports/ListToSendLFC";
import QuickLFCReports from "../letterForCounselling/reports/QuickLFCReports";
import AddBulkMembers from "../member/AddBulkParticipants";
import EditMember from "../member/EditMember";
import MemberDetails from "../member/MemberDetails/MemberDetails";
import AddLetterForCounselling from "../member/MemberLetterForCounselling/AddLetterForCounselling";
import EditLetterForCounselling from "../member/MemberLetterForCounselling/EditLetterForCounselling";
import MemberList from "../member/MemberList";
import MarkRafiqAsExRequest from "../member/MemberMarkEx/MarkRafiqAsExRequest";
import MemberMudarisDetailsFromList from "../member/MemberMudaris/MemberMudarisDetailsFromList";
import MemberMudriseen from "../member/MemberMudaris/MemberMudriseen";
import MemberResponsibilityRequest from "../member/MemberResponsibility/MemberResponsibilityRequest";
import MemberTypeRequest from "../member/MemberType/MemberTypeRequest";
import Members from "../member/Members";
import UpdateMember from "../member/UpdateMember/UpdateMember";
import UserPermissions from "../member/UserPermissions";
import MemberDocs from "../member/report/AttachedDocsReport/MemberDocs";
import ReportList from "../member/report/ReportList";
import MembersMeeting from "../membersMeeting/MembersMeeting";
import MemberRequests from "../notification/MemberRequests/MemberRequests";
import NotificationsTabs from "../notification/Notifications/NotificationsTabs";
import QuickReports from "../reports/QuickReports";
import CourseAttendees from "../reports/courses/CourseAttendees";
import InfaqReport from "../reports/infaq/InfaqReport";
import LfcKpiReport from "../reports/lfcReports/LfcKpiReport";
import MemberStatusChangeReport from "../reports/members/MemberStatusChange";
import UnitMemberCountReport from "../reports/members/MembersCount";
import UnitJaizaReport from "../reports/members/UnitJaizaReport";
import UnitMemberReport from "../reports/members/UnitMemberReport";
import UnitOfficialsReport from "../reports/members/UnitOfficialsReport";
import ArrivalsDeparturesReport from "../reports/members/arrival-departure/ArrivalsDepartures";
import ArrivalsDeparturesCummulative from "../reports/members/arrival-departure/ArrivalsDeparturesCummulative";
import MemberMudariseenReport from "../reports/mudariseen/MemberMudariseenReport";
import ReappointmentReport from "../reports/responsibilities/ReappointmentReport";
import VacantResponsibilitiesReport from "../reports/responsibilities/VacantResponsibilitiesReport";
import EditTutorial from "../tutorials/EditTutorial";
import SearchTutorials from "../tutorials/SearchTutorials";
import MoveUnitMembers from "../unit/MoveUnitMember";
import Unit from "../unit/Unit";
import CreateReports from "../unit/report/CreateReports/UsraMonthlyReport/CreateReports";
import CummulativeReport from "../unit/report/CummulativeReport";
import UnitMonthlyReport from "../unit/report/MonthlyReport";
import Users from "../users/Users";
import DocumentsRefactored from "../documents/DocumentsRefactored";

export default function SwitchRouter() {
  const isIncharge = encryptStorage.getItem("canManage");
  return (
    <Switch>
      <Route exact path="/">
        <DashBoard />
      </Route>
      <Route exact path="/personalInfo">
        <MemberDetails />
      </Route>
      <Route exact path="/notifications">
        <NotificationsTabs />
      </Route>
      <Route exact path="/memberRequests">
        <MemberRequests />
      </Route>
      {isIncharge ? (
        <>
          <Route exact path="/ahbab/">
            <Ahbab />
          </Route>
          <Route exact path="/ahbabprogressboard/">
            <AhbabProgressBoard />
          </Route>
          <Route exact path="/ahbab/report">
            <AhbabReport />
          </Route>
          <Route exact path="/ahbabFromContactForm/reports">
            <QuickTanzeemOrgAhbabReports />
          </Route>
          <Route exact path="/ahbabFromContactForm/reports/report">
            <AhbabFromContactFormReport />
          </Route>
          <Route exact path="/ahbabFromContactForm/reports/analyticsReport">
            <AhbabFromContactUsFormAnalyticsReport />
          </Route>
          <Route exact path="/ahbabFromContactForm/">
            <AhbabFromContactForm />
          </Route>
          <Route exact path="/ahbabFromContactForm/addHabib">
            <AddHabib />
          </Route>
          <Route exact path="/ahbabFromContactForm/editHabib/:id">
            <EditHabib />
          </Route>
          <Route exact path="/documents">
            <DocumentsRefactored />
          </Route>
          {/* <Route exact path="/documents/improve">
            <Documents />
          </Route> */}
          <Route exact path="/message/sms">
            <SMSReport />
          </Route>
          <Route exact path="/eventdetail">
            <EventDetail />
          </Route>
          <Route exact path="/infaqreport">
            <InfaqReport />
          </Route>
          <Route exact path="/infaqreport/unitwise">
            <Redirect to="/infaqreport?tab=unitWise" />
          </Route>
          <Route exact path="/fundsmanagement/report/infaq">
            <Redirect to="/infaqreport?tab=rafiqWise" />
          </Route>
          <Route exact path="/fundsmanagement">
            <Funds />
          </Route>
          <Route exact path="/fundsmanagement/addbulk">
            <AddBulkFund />
          </Route>
          <Route exact path="/eventReports/report">
            <EventReport />
          </Route>
          <Route exact path="/eventReports/summaryReport">
            <EventSummaryReport />
          </Route>
          <Route exact path="/event/eventparticipant">
            <EventParticipants />
          </Route>
          <Route exact path="/event/eventAttendance">
            <EventAttendance />
          </Route>
          <Route exact path="/event/eventAttendance/barCodeAttendance">
            <EventBarCodeAttendance />
          </Route>
          <Route exact path="/event/selectiveEventParticipant">
            <SelectiveEventParticipants />
          </Route>
          <Route exact path="/event/responsibleEventParticipants">
            <EventResponsibleParticipant />
          </Route>
          <Route exact path="/event/inChargeAndResponsibleEventParticipants">
            <EventInChargeAndResponsibleParticipants />
          </Route>
          <Route exact path="/event/editevent/:id">
            <EditEvent />
          </Route>
          <Route exact path="/event/addevent">
            <AddEvent />
          </Route>
          <Route exact path="/event">
            <Events />
          </Route>
          <Route exact path="/course/report/courseparticipants">
            <CourseParticipantsReport />
          </Route>
          <Route exact path="/course/report">
            <CourseReport />
          </Route>
          <Route exact path="/course/courseparticipant">
            <CourseParticipants />
          </Route>
          <Route exact path="/course/addcourse">
            <AddCourse />
          </Route>
          <Route exact path="/course/editcourse/:id">
            <EditCourse />
          </Route>
          <Route exact path="/course">
            <Courses />
          </Route>
          <Route exact path="/member/report">
            <ReportList />
          </Route>

          <Route exact path="/member/membersdetails/:id">
            <MemberDetails />
          </Route>
          <Route exact path="/member/editmember/:id">
            <EditMember />
          </Route>
          <Route exact path="/course/addbulkparticipant">
            <AddBulkMembers />
          </Route>
          <Route exact path="/member/updateMember/:id">
            <UpdateMember />
          </Route>
          <Route exact path="/member/memberResponsibilityRequest">
            <MemberResponsibilityRequest />
          </Route>
          <Route exact path="/member/updateMember/letterForCounselling/:id">
            <AddLetterForCounselling />
          </Route>
          <Route exact path="/member/viewLetterForCounselling/:id">
            <EditLetterForCounselling />
          </Route>
          <Route exact path="/member/updateMember/editLetterForCounselling/:id">
            <EditLetterForCounselling />
          </Route>
          <Route exact path="/member/memberTypeChangeRequest">
            <MemberTypeRequest />
          </Route>
          <Route exact path="/member">
            <Members />
          </Route>
          <Route exact path="/memberList">
            <MemberList />
          </Route>
          <Route exact path="/member/markAsExRequest">
            <MarkRafiqAsExRequest />
          </Route>
          <Route exact path="/member/mudaris/:id">
            <MemberMudarisDetailsFromList />
          </Route>
          <Route exact path="/unit/monthlyreport">
            <UnitMonthlyReport />
          </Route>
          <Route exact path="/unit/cummulativereport">
            <CummulativeReport />
          </Route>
          <Route exact path="/unit/movemembers">
            <MoveUnitMembers />
          </Route>
          <Route exact path="/unit">
            <Unit />
          </Route>
          <Route exact path="/updateBooks">
            <Books />
          </Route>
          <Route exact path="/meetingMembers">
            <MembersMeeting />
          </Route>
          <Route exact path="/unit/createReports">
            <CreateReports />
          </Route>
          <Route exact path="/mudariseen">
            <MemberMudriseen />
          </Route>
          <Route exact path="/reports">
            <QuickReports />
          </Route>
          <Route exact path="/reports/unitMember">
            <UnitMemberReport />
          </Route>
          <Route exact path="/reports/unitMemberCount">
            <UnitMemberCountReport />
          </Route>
          <Route exact path="/reports/unitJaiza">
            <UnitJaizaReport />
          </Route>
          <Route exact path="/reports/arrivalsDepartures">
            <ArrivalsDeparturesReport />
          </Route>
          <Route exact path="/reports/arrivalsDeparturesCummulative">
            <ArrivalsDeparturesCummulative />
          </Route>
          <Route exact path="/reports/vacantResponsibilitiesReport">
            <VacantResponsibilitiesReport />
          </Route>
          <Route exact path="/reports/mudariseen">
            <MemberMudariseenReport />
          </Route>
          <Route exact path="/reports/attachedDocumentsReport">
            <MemberDocs />
          </Route>
          <Route exact path="/reports/reappointmentMuqamiAmeer">
            <ReappointmentReport />
          </Route>
          <Route exact path="/reports/memberStatusChange">
            <MemberStatusChangeReport />
          </Route>
          <Route exact path="/reports/unitOfficials">
            <UnitOfficialsReport />
          </Route>
          <Route exact path="/reports/courseAttendees">
            <CourseAttendees />
          </Route>
          <Route exact path="/eventReports">
            <QuickEventReports />
          </Route>
          <Route exact path="/eventReports/rafiqWiseIjtimaAttendance">
            <RafiqWiseEventAttendance />
          </Route>
          <Route exact path="/eventReports/eventWiseIjtimaAttendance">
            <EventWiseEventAttendance />
          </Route>
          <Route exact path="/eventReports/unitWiseIjtimaAttendance">
            <UnitWiseEventAttendance />
          </Route>
          <Route exact path="/eventsReport/eventReportWithNoAttendance">
            <EventReportWithNoAttendance />
          </Route>
          <Route exact path="/config">
            <Configuration />
          </Route>
          <Route exact path="/users">
            <Users />
          </Route>
          <Route exact path="/userPermissions">
            <UserPermissions />
          </Route>
          <Route exact path="/videoTutorials">
            <SearchTutorials />
          </Route>
          <Route exact path="/update/:id">
            <EditTutorial />
          </Route>
          <Route exact path="/settingsEducations">
            <Education />
          </Route>
          <Route exact path="/letterForCounselling">
            <LetterForCounselling />
          </Route>
          <Route exact path="/letterForCounsellingReports">
            <QuickLFCReports />
          </Route>
          <Route exact path="/letterForCounsellingReports/listToSendLFC">
            <ListToSendLFC />
          </Route>
          <Route exact path="/letterForCounsellingReports/LfcKpiReport">
            <LfcKpiReport />
          </Route>
        </>
      ) : null}
    </Switch>
  );
}
